export default "__VITE_ASSET__6xXvpphC__"